import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import MUITextField from '@mui/material/TextField';
import { checkLegalEntityId } from '@fnol/library/src/lib';

export type LegalEntityIdFieldProps = {
    name: string;
    label: string;
    required?: boolean;
    selectedCountry?: string | number;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
};

const LegalEntityIdField = ({
    name,
    label,
    required,
    selectedCountry,
    onChange,
    onBlur,
    ...rest
}: LegalEntityIdFieldProps) => {
    const { values, setFieldValue } = useFormikContext<any>();

    const legalEntityIdFieldChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setFieldValue(name, e.currentTarget.value);
        onChange?.(e);
    };

    useEffect(() => {
        if (
            values[name] !== '' &&
            (selectedCountry === 197 || selectedCountry === '197') &&
            !checkLegalEntityId(values[name])
        ) {
            setFieldValue('legalEntityIdFieldFormatError', true);
        } else {
            setFieldValue('legalEntityIdFieldFormatError', false);
        }
    }, [selectedCountry, values[name]]);

    return (
        <MUITextField
            required={required}
            name={name}
            label={label}
            onChange={legalEntityIdFieldChangeHandler}
            onBlur={onBlur}
            {...rest}
        />
    );
};

export default LegalEntityIdField;
